export default __webpack_public_path__ + "static/media/svg-3.6e1cabf7.svg";